import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {components} from '../components';

import { Mail } from 'lucide-react';

import Https from '../utils/apiUtility';

interface SubscriberType {
  email: string;
}


export const ForgotPassword: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();
    const [subscriber, setSubscriber] = useState<SubscriberType | null>(null);

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const fetchSubscriber = async () => {
      try {
        const response = await Https.get("/assinante");
        setSubscriber(response.data);
      } catch (error) {
        console.error("Erro ao buscar assinante:", error);
      }
    };

    fetchSubscriber();
  }, []);

  const renderBackground = (): JSX.Element => {
    return <components.Background />;
  };

  const renderHeader = () => {
    return (
      <components.Header
        title='Esqueceu sua senha'
        goBack={true}
      />
    );
  };

  const renderContent = () => {
    return (
      <main style={{padding: '30px 20px 20px 20px', marginTop: 52}}>
        <text.T16 style={{marginBottom: 30, color: theme.colors.textColor}}>
          Por favor, insira seu endereço de e-mail. Você receberá um link para criar um
          nova senha por e-mail.
        </text.T16>
        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8, // Padding interno do ícone
                backgroundColor: theme.colors.lightGrey, // Cor de fundo do ícone
                borderRadius: '20%', // Deixa o ícone circular
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Mail size={18} color={theme.colors.mainDark} />
            </div>
          }
          // rightIcon={<svg.CheckSvg />}
          placeholder={subscriber?.email}
          containerStyle={{marginBottom: 14}}
        />
        <components.Button
          title='Enviar'
          onClick={() => {
            navigate('/NewPassword');
          }}
        />
      </main>
    );
  };

  return (
    <div id='screen'>
      {/* {renderBackground()} */}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
